import React from 'react';
import {Link, LinkProps} from 'react-router-dom';

export default React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <Link innerRef={ref as any} {...props} />
));
